import { render, staticRenderFns } from "./SavedPostsIcon.vue?vue&type=template&id=5184ecc0&scoped=true"
import script from "./SavedPostsIcon.vue?vue&type=script&lang=js"
export * from "./SavedPostsIcon.vue?vue&type=script&lang=js"
import style0 from "./SavedPostsIcon.vue?vue&type=style&index=0&id=5184ecc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5184ecc0",
  null
  
)

export default component.exports